import { ShopScopeSelect } from "@/components/layout/shop-scope-select";
import { ReportingPeriodSelect } from "@/components/patterns/reporting-period-select";
import { ReportingTimeZoneSelect } from "@/components/patterns/reporting-time-zone-select";
import { useReportingPeriodStore } from "@/stores/reporting-period";
import { useReportingTimeZoneStore } from "@/stores/reporting-time-zone";

interface ReportingFiltersProps {
  /** Resource reports follow their own Shop; an ambient Shop filter would be misleading. */
  scope?: "workspace" | "resource";
}

export function ReportingFilters({ scope = "workspace" }: ReportingFiltersProps) {
  const period = useReportingPeriodStore((state) => state.period);
  const setPeriod = useReportingPeriodStore((state) => state.setPeriod);
  const timeZone = useReportingTimeZoneStore((state) => state.timeZone);
  const setTimeZone = useReportingTimeZoneStore((state) => state.setTimeZone);
  return (
    <div data-reporting-filters className="flex max-w-full flex-wrap items-center gap-2">
      <ReportingTimeZoneSelect value={timeZone} onValueChange={setTimeZone} />
      <ReportingPeriodSelect value={period} timeZone={timeZone} onValueChange={setPeriod} />
      {scope === "workspace" ? <ShopScopeSelect /> : null}
    </div>
  );
}
